// Script para crear categorías básicas desde la consola del navegador
// Ejecutar: window.createBasicCategories()

export {};

(window as any).createBasicCategories = async function() {
  console.log('🚀 Creando categorías básicas...');
  
  try {
    // Verificar que Firebase esté disponible
    if (!(window as any).auth) {
      throw new Error('Firebase no está disponible');
    }
    
    const { db, collection, doc, setDoc, serverTimestamp } = (window as any).auth;
    
    // Obtener el ID del usuario actual
    const userId = (window as any).auth.auth.currentUser?.uid;
    if (!userId) {
      throw new Error('Usuario no autenticado');
    }

    console.log(`👤 Usuario: ${userId}`);

    // Definir categorías básicas
    const categories = {
      'REMERA': {
        name: 'REMERA',
        fields: {
          talle: {
            type: 'select',
            options: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
            required: true
          },
          color: {
            type: 'text',
            required: true
          }
        },
        enabled: true
      },
      
      'PANTALON': {
        name: 'PANTALON',
        fields: {
          talle: {
            type: 'select',
            options: ['28', '30', '32', '34', '36', '38', '40', '42', '44'],
            required: true
          },
          color: {
            type: 'text',
            required: true
          }
        },
        enabled: true
      },
      
      'CAMPERA': {
        name: 'CAMPERA',
        fields: {
          talle: {
            type: 'select',
            options: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
            required: true
          },
          color: {
            type: 'text',
            required: true
          }
        },
        enabled: true
      },
      
      'BUZO': {
        name: 'BUZO',
        fields: {
          talle: {
            type: 'select',
            options: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
            required: true
          },
          color: {
            type: 'text',
            required: true
          }
        },
        enabled: true
      },
      
      'ACCESORIOS': {
        name: 'ACCESORIOS',
        fields: {
          tipo: {
            type: 'select',
            options: ['Gorra', 'Bufanda', 'Guantes', 'Cinturón', 'Otros'],
            required: true
          },
          color: {
            type: 'text',
            required: true
          }
        },
        enabled: true
      }
    };

    // Crear cada categoría
    for (const [categoryName, categoryData] of Object.entries(categories)) {
      console.log(`📂 Creando categoría: ${categoryName}`);
      
      // Crear documento en Firestore
      const categoryRef = doc(db, 'users', userId, 'categories', categoryName);
      await setDoc(categoryRef, {
        ...categoryData,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      });
      
      console.log(`✅ Categoría "${categoryName}" creada exitosamente`);
    }
    
    console.log('🎉 Categorías básicas creadas exitosamente');
    console.log('📋 Estructura creada:');
    console.log('   - Colección: users/{userId}/categories/');
    console.log('   - Productos: users/{userId}/categories/{category}/stock/{SKU}');
    
    return {
      success: true,
      message: 'Categorías básicas creadas exitosamente',
      categories: Object.keys(categories)
    };
    
  } catch (error) {
    console.error('❌ Error creando categorías:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : error
    };
  }
};

console.log('🔧 Script de categorías básicas cargado');
console.log('💡 Usa: window.createBasicCategories()');
